<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <line x1="22" y1="2" x2="15" y2="2" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
    <line x1="22" y1="9" x2="22" y2="2" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
    <line x1="22" y1="2" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"></line>
    <polyline stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" points="11.9411765 5 4 5 4 21 19 21 19 12.5294118"></polyline>
  </g>
</svg>
